module.exports = __webpack_public_path__ + "7e2344ef604f0b15165b6a07d7735a37.jpg";